<template>
  <span>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': groupId == null }"
      href="/customers/group/group_id/message/sms/"
      v-tooltip="{
        content: $label(
          'group.sms_to_all_group_members',
          'SMS to all group members'
        ),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-mobile"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': groupId == null }"
      href="/customers/group/group_id/message/email/"
      v-tooltip="{
        content: $label(
          'group.email_to_all_group_members',
          'Email to all group members'
        ),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-envelope-o"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': groupId == null }"
      href="/settings/groups/group_id/lock/"
      v-tooltip="{
        content: $label(
          'group.lock_all_group_members',
          'Lock all group members'
        ),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-lock"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': groupId == null }"
      href="/settings/groups/group_id/unlock/"
      v-tooltip="{
        content: $label(
          'group.unlock_all_group_members',
          'Unlock all group members'
        ),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-unlock"></i>
    </a>
  </span>
</template>

<script>
export default {
  name: "GroupActions",

  props: ["groupId"]
};
</script>

<style scoped></style>
